import * as React from "react";
import * as ProgressPrimitive from "@radix-ui/react-progress";

import { cn } from "../../lib/utils";

const StackedProgress = React.forwardRef(({ className, segments, ...props }, ref) => {
  return (
    <ProgressPrimitive.Root
      ref={ref}
      className={cn("relative h-4 w-full overflow-hidden rounded-full bg-secondary", className)}
      {...props}
    >
      {segments.map((segment, index) => (
        <ProgressPrimitive.Indicator
          key={index}
          className={cn("h-full transition-all absolute", segment.color ? segment.color : "bg-primary")}
          style={{
            width: `${segment.value}%`,
            left: `${segments.slice(0, index).reduce((sum, s) => sum + s.value, 0)}%`,
            zIndex: segments.length - index,
          }}
        />
      ))}
    </ProgressPrimitive.Root>
  );
});

StackedProgress.displayName = "StackedProgress";

export { StackedProgress };
